import React from 'react';
import { HiOutlineMenuAlt2, HiOutlineQuestionMarkCircle } from 'react-icons/hi';
import Icon from './Icon';
import NotificationBell from './NotificationBell';
import ProfileDropdown from './ui/ProfileDropdown';
import SettingsDropdown from './ui/SettingsDropdown';
import ActingTenantSelector from './ActingTenantSelector';
import RequireRole from '@/components/auth/RequireRole';

interface HeaderProps {
  onToggleSidebar: () => void;
  sidebarOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar, sidebarOpen }) => {
  return (
    <header className="bg-white border-b border-gray-200 px-4 py-3 h-16">
      <div className="flex items-center justify-between">
        {/* Left side - Menu toggle (only show when sidebar is closed) */}
        <div className="flex items-center">
          {!sidebarOpen && (
            <button
              onClick={onToggleSidebar}
              className="text-gray-500 hover:text-gray-700 transition-colors p-2 rounded-md hover:bg-gray-100"
            >
              <Icon icon={HiOutlineMenuAlt2} className="w-5 h-5" />
            </button>
          )}
        </div>

        {/* Right side - User actions */}
        <div className="flex items-center space-x-4">
          <RequireRole allowedRoles={['SUPER_USER']}>
            <ActingTenantSelector />
          </RequireRole>
          <NotificationBell />
          <SettingsDropdown />
          <button className="p-2 text-gray-500 hover:text-gray-700 transition-colors rounded-md hover:bg-gray-100">
            <Icon icon={HiOutlineQuestionMarkCircle} className="w-5 h-5" />
          </button>
          <ProfileDropdown />
        </div>
      </div>
    </header>
  );
};

export default Header;
